import React from 'react';
import { get, map } from 'lodash';
import { updateListing, fetchListingInfo } from '../../../app-main/actions/listing';
import { toggleBanner } from '../../../app-main/actions/banner';
import { updateShowVariableAttendeeForm } from '../../../app-main/actions/calendarPricing';
import { SubmissionError } from 'redux-form';
import { FormattedMessage } from 'react-intl';


const onSubmitAttendeePriceForm = (values, dispatch, props) => {
  const accessToken = get(props, 'accessToken', '');
  const listing = get(props, 'listing', {});
  const listingId = listing._id;
  const { tiers = [], number_guests } = values;
  const payload = {
    attendee_pricing: {
      apply_as: 'HOURLY_RATE_ADDITION',
      obj_state: 'ACTIVATED',
      tiers
    },
    number_guests
  };

  const errorMessage = <FormattedMessage id="hosting.on_submit_attendee_price_form.error_message" defaultMessage="Something went wrong, please try again." />;

  return dispatch(updateListing(listingId, accessToken, payload))
    .then((listingRes) => {
      dispatch(toggleBanner('save'));
      dispatch(updateShowVariableAttendeeForm(false));
      dispatch(fetchListingInfo(listingId));

      const analyticsPayload = {
        listing_id: listingId,
        metro: listing.metro,
        use_type: listing.use_type,
        base_rate: get(listing, 'prices.0.value', ''),
        max_attendees: listing.number_guests,
        attendee_rate_tier_count: get(listingRes, 'attendee_pricing.tiers', []).length,
        attendee_rate_object: payload,
        is_new_rate: 0 < get(listing, 'attendee_pricing.tiers', []).length ? 'updated_rate' : 'new_rate'
      };

      analyticsIntegrations.calendarPricingAction('attendee_rate_saved', analyticsPayload);
    })
    .catch((error) => {
      const tiersError = map(get(error, 'validated_tiers'), (errObj) => get(errObj, 'errors.0', ''));
      const errorDetails = get(error, 'error_details').join(', ');

      throw new SubmissionError({
        _error: errorDetails || errorMessage,
        tiers: { _error: tiersError }
      });
    });
};

export default onSubmitAttendeePriceForm;
